import { render, staticRenderFns } from "./CancelSubscriptions.vue?vue&type=template&id=2d1338f5&scoped=true"
import script from "./CancelSubscriptions.vue?vue&type=script&lang=js"
export * from "./CancelSubscriptions.vue?vue&type=script&lang=js"
import style0 from "./CancelSubscriptions.vue?vue&type=style&index=0&id=2d1338f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1338f5",
  null
  
)

export default component.exports